// Town–School Memorandum of Agreement Data
// March 29, 2026
//
// Source: "PSB-TOB MOU 2026.pdf" in the Town App / "Town School MOU 2026-03-29"
// Drive folder. The goals and preamble were extracted programmatically from
// that PDF and are transcribed faithfully — wording, punctuation and spacing as
// in the source, including "Town /School" in goal 2. The PDF's invisible
// zero-width spaces and its line wrapping were removed; nothing else was.
//
// The page always calls this a Memorandum of Agreement, matching the document's
// own heading (`formalTitle`), which is quoted verbatim. It was called a
// Memorandum of Understanding until 2026-09-22, when Michael asked for the page
// to follow the document. Goal 2's mention of an "MOU dated October 2025" is the
// source's own text about a different, earlier document, and stays as written.
//
// Responsible parties: the source tags each goal "(PSB)" or "(PSB, TOB)". They
// are spelled out as "Schools" (PSB) and "Town" (TOB), in the source's order.
// Abbreviations inside the goal text (e.g. "PSB buildings") are left as
// written; the formal title below defines them.

export const townSchoolMoaData = {
  shortTitle: "Town–School Memorandum of Agreement",
  formalTitle: "Memorandum of Agreement Between the Town of Brookline (TOB) and the Public Schools of Brookline (PSB)",
  adoptedDate: "March 29, 2026",
  preamble: [
    "Whereas, it is well-documented that Brookline, along with many other municipalities in the Commonwealth, is struggling to align expenses with revenues, and desires to improve its financial sustainability; and,",
    "Whereas, the Brookline Expenditures & Revenues Study Committee (ERSC), which recently concluded its analysis, made multiple recommendations about how Brookline might consider modifications to expenditures and revenues, in the short-term and long-term; and,",
    "Whereas, the ERSC also recommended a memorandum of agreement to extend the ongoing close collaboration between the Town of Brookline and the Public Schools of Brookline to continue to investigate these recommendations, following the previously successful MOA of fall 2025; and,",
    "Whereas, the TOB Administrator and the PSB Superintendent are also enthusiastic to continue their collaboration and optimize the finances and operations of the TOB and PSB, for the benefit of the Brookline Community; therefore,",
  ],
  leadIn: "School Administration in collaboration with Town Administration commits to:",
  goals: [
    {
      number: 1,
      text: "Evaluate the school model, which will include consideration of creating middle schools and/or other configurations.",
      responsible: ["Schools"],
    },
    {
      number: 2,
      text: "Complete the work included in the Town /School MOU dated October 2025 with respect to using MUNIS as the town-wide financial system of record by the end of fiscal 2027.",
      responsible: ["Schools", "Town"],
    },
    {
      number: 3,
      text: "Confirm teaching assignments align with contractual terms, while maintaining student support programming.",
      responsible: ["Schools"],
    },
    {
      number: 4,
      text: "Evaluate technology financial efficiencies when considering the maintenance of educational objectives.",
      responsible: ["Schools"],
    },
    {
      number: 5,
      text: "Evaluate the policy and practice of the use of space in PSB buildings by non-school entities for the purposes of determining appropriate reimbursement or remuneration for the use of such spaces during or outside of school hours.",
      responsible: ["Schools", "Town"],
    },
    {
      number: 6,
      text: "Evaluate the policy and practice of use of PSB properties for youth athletics to optimize coordination and efficiency of scheduling.",
      responsible: ["Schools", "Town"],
    },
    {
      number: 7,
      text: "Evaluate the policy and practice regarding the governance of facilities management to optimize coordination with shared goals and planning.",
      responsible: ["Schools", "Town"],
    },
    {
      number: 8,
      text: "Review BEEP financials to ensure the funding of its programming, designed to meet identified mandated student needs, is financially prudent and geared toward a status of being self-funded if possible.",
      responsible: ["Schools"],
    },
    {
      number: 9,
      text: "Bargain in good faith with all units with an aim toward establishing sustainable financial stability and retention.",
      responsible: ["Schools", "Town"],
    },
    {
      number: 10,
      text: "Evaluate shared assets and services for improved operational efficiency without detriment to service.",
      responsible: ["Schools", "Town"],
    },
  ],
};
